// Central data for all 4 services — used by pages and the mega menu
const SERVICES_DATA = {
    "marble-polishing": {
        slug: "marble-polishing",
        title: "Marble Polishing",
        tagline: "Restore the mirror-like brilliance your marble deserves.",
        heroImage: "/Marble%20polish/banner/67011d89e8a31_Banner%20-%20-Marble-Flooring-For-Home.jpg",
        accent: "#D4AF37",
        overview:
            "Over time, marble surfaces accumulate scratches, stains and dullness that diminish their natural beauty. Our professional marble polishing service uses industry-leading diamond abrasive pads and premium polishing compounds to cut through surface damage, remove etch marks and restore a flawless mirror finish — leaving every slab gleaming exactly as nature intended.",
        process: [
            { step: "01", title: "Assessment", desc: "We inspect the stone type, finish and damage level to select the right polishing protocol." },
            { step: "02", title: "Grinding & Honing", desc: "Diamond-grit pads remove scratches and level the surface progressively from coarse to fine grades." },
            { step: "03", title: "Polishing", desc: "High-speed polishing with compound brings out the natural crystalline shine of the stone." },
            { step: "04", title: "Sealing", desc: "An impregnating sealer is applied to protect against future staining and moisture." },
            { step: "05", title: "Final Buffing", desc: "A last hand-buff and quality check ensures a showroom-perfect, streak-free finish." },
        ],
        benefits: [
            "Restores original gloss without replacement costs",
            "Removes scratches, etching & dull patches",
            "Extends the life of your marble by decades",
            "Eco-friendly dry polishing process — no harsh chemicals",
            "Same-day service available for most residential projects",
            "All marble types: Carrara, Calacatta, Emperador & local stone",
        ],
        gallery: [
            "/Marble%20polish/2.jpeg",
            "/Marble%20polish/6.jpeg",
            "/Marble%20polish/8.jpeg",
            "/Marble%20polish/9.jpeg",
            "/Marble%20polish/10.jpeg",
            "/Marble%20polish/WhatsApp%20Image%202026-02-22%20at%206.43.59%20PM.jpeg",
        ],
        faq: [
            { q: "How long does marble polishing take?", a: "A standard room (up to 50 m²) takes 4–8 hours. Larger projects are quoted individually." },
            { q: "Will the furniture need to be moved?", a: "Yes, we request the area be clear. We can assist with light furniture movement." },
            { q: "How often should marble be polished?", a: "High-traffic floors every 1–2 years; lower-traffic surfaces every 3–5 years." },
            { q: "Is it safe for children and pets?", a: "Absolutely. Our dry-polishing and water-based sealers are non-toxic once cured." },
        ],
    },

    "tile-marble-installation": {
        slug: "tile-marble-installation",
        title: "Tile & Marble Installation",
        tagline: "Precision-cut surfaces, perfectly laid — every time.",
        heroImage: "/Marble%20polish/m3.jpg",
        accent: "#C5A028",
        overview:
            "From grand foyer floors to intricate bathroom feature walls, our expert installation team delivers perfectly aligned, seamlessly grouted tile and marble surfaces. We work with every format — from micro-mosaic inlays to 1200×2400 mm porcelain slabs — using precision laser-guided layouts and high-bond adhesives rated for the UAE climate.",
        process: [
            { step: "01", title: "Design & Layout", desc: "We plan the tile layout digitally, optimising cuts and pattern alignment before a single tile is placed." },
            { step: "02", title: "Surface Preparation", desc: "Substrate is checked for flatness, primed and waterproofed where required." },
            { step: "03", title: "Setting", desc: "Tiles are laid using laser-guided lines, premium adhesive and calibrated spacers for consistent joints." },
            { step: "04", title: "Grouting", desc: "Joints are filled with colour-matched, anti-fungal grout and finished neatly." },
            { step: "05", title: "Sealing & Finishing", desc: "Natural stone is sealed; edges are finished with polished trim or matching cove pieces." },
        ],
        benefits: [
            "Large-format slabs up to 1200×2400 mm — no visible joins",
            "Laser-guided precision — perfectly square every time",
            "Climate-rated adhesives for UAE heat and humidity",
            "In-house waterproofing for wet areas",
            "Matched grout colours and custom inlay patterns",
            "Full clean-up and waste removal included",
        ],
        gallery: [
            "/Marble%20polish/1.jpeg",
            "/Marble%20polish/3.jpeg",
            "/Marble%20polish/4.jpeg",
            "/Marble%20polish/5.jpeg",
            "/Marble%20polish/7.jpeg",
            "/Marble%20polish/11.jpeg",
        ],
        faq: [
            { q: "Do you supply the tiles as well?", a: "We can source premium tiles from our supplier network, or install tiles you have already purchased." },
            { q: "How long before we can walk on the floor?", a: "Light foot traffic after 24 hours; full load-bearing after 72 hours." },
            { q: "Can you install underfloor heating beneath tiles?", a: "Yes. We install and commission electric underfloor heating systems before tiling." },
            { q: "Do you handle outdoor areas?", a: "Yes, using porcelain and natural stone rated for UAE UV and thermal cycles." },
        ],
    },

    "ceiling-works": {
        slug: "ceiling-works",
        title: "Ceiling Works",
        tagline: "Dramatic ceilings that define luxury from above.",
        heroImage: "/Ceiling/10.webp",
        accent: "#B4901E",
        overview:
            "The ceiling is the fifth wall — and in luxury design, it commands as much attention as any other surface. Royal Standard's ceiling specialists design and install gypsum board systems, coffered panels, tray ceilings, curved soffits and cove lighting channels that transform ordinary rooms into architectural statements. All systems are engineered for UAE seismic and temperature standards.",
        process: [
            { step: "01", title: "Design Consultation", desc: "We collaborate with you (or your interior designer) to create a ceiling concept that suits the space and lighting plan." },
            { step: "02", title: "Structural Survey", desc: "Our team assesses slab height, MEP routing and load-bearing capacity before drawing shop plans." },
            { step: "03", title: "Framework Installation", desc: "Galvanised steel channels and hangers are installed to engineered drawings." },
            { step: "04", title: "Boarding & Plastering", desc: "Moisture-resistant gypsum boards are fixed, jointed and skimmed to a perfect flat surface." },
            { step: "05", title: "Feature Elements", desc: "Cornices, coffers, medallions and cove channels are formed and integrated." },
            { step: "06", title: "Finishing", desc: "Surface is primed and handed over ready for your decorator's paint scheme." },
        ],
        benefits: [
            "Full design service — concept to completion",
            "Fire-rated and moisture-resistant board options",
            "Integrated cove lighting and indirect LED channels",
            "Coffered, tray, barrel-vault and bespoke curved profiles",
            "All work complies with UAE building codes",
            "Dust-minimising tools and full site protection",
        ],
        gallery: [
            "/Ceiling/2.jpg",
            "/Ceiling/6.webp",
            "/Ceiling/13.jpg",
            "/Ceiling/4.jfif",
            "/Ceiling/1.jpg",
            "/Ceiling/3.jfif",
        ],
        faq: [
            { q: "Can you work around existing light fittings and AC grilles?", a: "Yes. We coordinate with MEP contractors and cut precise openings for all existing and new fixtures." },
            { q: "What ceiling height is required for a tray ceiling?", a: "We recommend a minimum of 2.8 m to achieve a proportionate tray. Lower heights can use alternative profiles." },
            { q: "How long does a false ceiling take to install?", a: "A standard living room (30–40 m²) typically takes 3–5 days including skimming and drying time." },
            { q: "Will there be a lot of dust and mess?", a: "We use negative-pressure dust control and seal all openings. Full clean-up is included." },
        ],
    },

    "joinery-carpentry": {
        slug: "joinery-carpentry",
        title: "Joinery & Carpentry",
        tagline: "Bespoke woodwork crafted with precision and passion.",
        heroImage: "/Joinery/5.jpeg",
        accent: "#D4AF37",
        overview:
            "Our master joiners design and build custom furniture, cabinetry and architectural woodwork that is unique to your space. From walk-in wardrobes lined in walnut veneer to kitchen islands with handcrafted dovetail drawers, every piece is engineered in our workshop, finished to exacting standards and installed with millimetre precision — turning your interiors into handcrafted masterpieces.",
        process: [
            { step: "01", title: "Site Survey & Brief", desc: "We measure your space, understand your lifestyle needs and review material and finish preferences." },
            { step: "02", title: "Workshop Fabrication", desc: "Each piece is machined, jointed and finished in our temperature-controlled workshop using premium solid timber and veneers." },
            { step: "03", title: "Finishing & Lacquering", desc: "Hand-sanded surfaces receive spray lacquer, high-gloss or matt polyurethane, painted or natural oil finishes." },
            { step: "04", title: "Site Installation", desc: "Factory-fit units are delivered and installed with seamless scribing to walls, floors and ceilings." },
        ],
        benefits: [
            "Fully bespoke — designed around your exact space",
            "Premium hardwoods: walnut, oak, teak, MDF-core veneers",
            "Soft-close, push-to-open and smart storage mechanisms",
            "10-year structural warranty on all joinery",
            "Matching architectural trim and feature wall panels",
        ],
        gallery: [
            "/Joinery/6.jpeg",
            "/Joinery/11.jpeg",
            "/Joinery/9.jpeg",
            "/Joinery/10.jpeg",
            "/Joinery/8.jpeg",
            "/Joinery/13.jpeg",
        ],
        faq: [
            { q: "How long does a custom wardrobe take from order to installation?", a: "Typically 4–6 weeks from signed design approval to installation, depending on complexity." },
            { q: "Can you match existing joinery in my home?", a: "Yes. We routinely match existing profiles, colours and hardware to extend or replace existing pieces." },
            { q: "Do you offer a design-only service?", a: "We offer full design + supply + install. Design-only can be arranged for clients using their own contractors." },
            { q: "What wood species do you recommend for UAE climate?", a: "Engineered MDF-core boards with real-wood veneers perform best — they resist humidity-related warping." },
        ],
    },
};

export default SERVICES_DATA;
